<template>
  <div>
    <dx-data-grid
      :data-source="getIssuesDataSource"
      :columns="getIssuesColumns"
      @toolbar-preparing="onToolbarPreparing($event)"
      class="e-appointment-details"
      :row-alternation-enabled="true"
      :columnChooser="{
        enabled: false,
      }"
      :pager="{ visible: false }"
      :height="height"
      :selection="{
        mode: 'none',
      }"
      ref="issues-tab-grid"
      @content-ready="onContentReady"
    >
      <DxScrolling
        :mode="'virtual'"
        :row-rendering-mode="'virtual'"
        :preload-enabled="true"
      />

      <template #issued-qty-template="{ data }">
        <div v-if="data.value > 0">
          <a @click="onIssuedQtyClicked(data)">{{ data.text }}</a>
        </div>
        <div v-else-if="data.value < 0" class="hyperlink negative">
          <a @click="onIssuedQtyClicked(data)">{{ data.text }}</a>
        </div>
        <div v-else class="hyperlink zero">
          <a @click="onIssuedQtyClicked(data)">-</a>
        </div>
      </template>

      <template #Decimal="{ data }">
        <GcDecimal :dataValue="data" :format="data.column.format" />
      </template>

      <template #menu-cell-template="{ data }">
        <DxDropDownButton
          :items="[
            {
              menuText: 'Return',
              data: data,
            },

            {
              menuText: 'Issue',
              data: data,
            },
          ]"
          keyExpr="menuText"
          displayExpr="menuText"
          :drop-down-options="{ width: 100 }"
          class="gc-dropdown-icon-button"
          icon="overflow"
          styling-mode="text"
          :show-arrow-icon="false"
        />
      </template>
    </dx-data-grid>

    <gcPopupMaterialIssueInfo
      :popupConfig="releasePopupInfo"
      :onHide="releasePopupHide"
      :displayServerError="displayServerError"
      :showLoading="showLoading"
      @onRefreshDataList="onRefreshDataList"
      v-if="releasePopupInfo.isPopupShow"
    />
  </div>
</template>

<script>
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
// import { getSortSettingsFromCombinedSetting } from "../../../_helpers/views/work-order";
import dataGridMixin from "../../../_mixins/data-grid.mixin";
import { WorkOrderService } from "../../../_services/api/production/work-order.service";
import SettingsService from "../../../_services/api/settings/graycorp/settings.service";
// import { FeatureStorage } from "../../../_services/storage";
import gcPopupMaterialIssueInfo from "../../../popups/work-order/gc-popup-material-issue-info.vue";

export default {
  mixins: [dataGridMixin],
  components: {
    gcPopupMaterialIssueInfo,
  },
  props: {
    dataModel: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: Number,
      default: 280,
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      releasePopupInfo: {
        isPopupShow: false,
        dataModel: {},
      },
      WorkOrderInstance: "Core",
    };
  },
  async created() {
    await this.loadWorkOrderInstance();

    // This is commented out, because API side is applied the GroupBy settings & sorting settings
    // If you want to apply the sorting settings on the client side, uncomment this code
    // Also uncomment the import getSortSettingsFromCombinedSetting function

    // const WOMaterialIssueViewDefaultSortColumns =
    //   await getSortSettingsFromCombinedSetting(
    //     "WOMaterialIssueViewDefaultSortColumns",
    //     this.getIssuesColumns.map((col) => col.dataField)
    //   );

    // if (WOMaterialIssueViewDefaultSortColumns.length > 0) {
    //   WOMaterialIssueViewDefaultSortColumns.forEach((element) => {
    //     const targetCol = this.getIssuesColumns.find(
    //       (col) => col.dataField === element.dataField
    //     );

    //     if (targetCol) {
    //       targetCol.sortOrder = element.sortOrder;
    //       targetCol.sortIndex = element.sortIndex;
    //     }
    //   });

    //   this.$nextTick(() => {
    //     const dataGrid = this.$refs["issues-tab-grid"].instance;
    //     if (dataGrid) {
    //       dataGrid.option("columns", this.getIssuesColumns);
    //       dataGrid.refresh(true);
    //     }
    //   });
    // }
  },
  methods: {
    async loadWorkOrderInstance() {
      let workOrderInstanceSetting = await SettingsService.getBySettingName(
        "WorkOrderInstance"
      );

      if (workOrderInstanceSetting.data.value.length > 0) {
        this.WorkOrderInstance =
          workOrderInstanceSetting.data.value[0].SettingValue;
      }
    },
    releasePopupHide() {
      this.releasePopupInfo.isPopupShow = false;
    },
    async onRefreshDataList() {
      let dataGrid = this.$refs["issues-tab-grid"].instance;
      if (dataGrid) {
        dataGrid.refresh(true).then(() => {
          this.$nextTick(() => {
            this.$emit("onRefreshWorkOrderHeader");
            this.$emit("onRefreshDataList");
          });
        });
      } else {
        this.$nextTick(() => {
          this.$emit("onRefreshWorkOrderHeader");
          this.$emit("onRefreshDataList");
        });
      }
    },
    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },
    onIssuedQtyClicked(data) {
      const lineData = data.data;
      this.releasePopupInfo.dataModel = {
        ...lineData,
        ProductDescription: lineData.ProductDescription1,
        ReleaseDate: lineData.DateIn,
        ProductDisplay: `${lineData.ProductCode} - ${lineData.ProductDescription1}`,
      };

      this.releasePopupInfo.isPopupShow = true;
    },
    onContentReady(e) {
      this.addGridNoResults(e, {
        addNew: {
          class: "add-new",
          title: "No Issues",
          message: "No Material Issue has been made to this work order",
        },
      });

      this.$nextTick(() => {
        e.component.beginUpdate();
        e.component.updateDimensions();
        e.component.endUpdate();
      });
    },
  },
  computed: {
    getIssuesDataSource() {
      return WorkOrderService.dataSourceConfig(
        "api/MaterialIssueDetailGrouped?WorkOrderCode=" +
          parseInt(this.dataModel.WorkOrderCode),
        {
          // filter: `WorkOrderCode eq ${this.dataModel.WorkOrderCode}`,
        }
      );
    },
    getIssuesColumns() {
      return [
        {
          caption: "Material",
          dataField: "ProductCode",
          width: ColumnWidth.ProductCode.width,
          minWidth: ColumnWidth.ProductCode.minWidth,
        },
        {
          caption: "Description",
          dataField: "ProductDescription1",
          // minWidth: ColumnWidth.Description.minWidth,
          // width: ColumnWidth.Description.width,
        },
        {
          caption: "Process",
          dataField: "ProcessCode",
          minWidth: ColumnWidth.ProcessCode.minWidth,
          width: ColumnWidth.ProcessCode.width,
        },
        {
          caption: "Date In",
          dataField: "DateIn",
          dataType: "date",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
        },
        {
          caption: "Issue Type",
          dataField: "IssueType",
          minWidth: ColumnWidth.IssueType.minWidth,
          width: ColumnWidth.IssueType.width,
        },
        {
          caption: "Issued Qty",
          dataField: "Issued",
          dataType: "number",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "issued-qty-template",
        },
        {
          caption: "Stock UM",
          dataField: "StockUM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          width: ColumnWidth.UnitOfMeasure.width,
        },
        // {
        //   caption: "",
        //   dataField: "",
        //   cellTemplate: "menu-cell-template",
        //   width: 50,
        //   visible: FeatureStorage.checkPermission(
        //     "WorkOrderMaterialIssue",
        //     "create"
        //   ),
        // },
      ];
    },
  },
};
</script>

<style lang="scss">
.e-appointment-details {
  .day-event-template {
    padding: 5px 5px;

    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .subject span:last-child {
      font-size: 10px;
    }

    .description {
      font-size: 12px;
    }

    .data {
      font-size: 10px;
      display: inline-flex;
      justify-content: space-between;
      width: 100%;

      .data-items {
        display: flex;
      }

      .actual {
        padding-left: 25px;
      }
    }
  }
}
</style>
